import React from "react";
import { Text4, Text5 } from "../../../styles";
import { printRupee } from "../../../app_methods";
import moment from "moment";
import { Badge, Icon, Button } from "antd";

export const STATUSTYPES = {
  paid: {
    key: "paid",
    value: 3,
    label: "Paid",
    color: "green",
    description: "GST Challan is paid & Debit Advice has been generated.",
  },
  processing: {
    key: "processing",
    value: 2,
    label: "Processing",
    color: "blue",
    description: "GST Challan payment is initiated but is pending at bank's end.",
  },
  unpaid: {
    key: "unpaid",
    value: 1,
    label: "Unpaid",
    color: "orange",
    description: "GST Challan payment is not yet initiated.",
  },
  unapproved: {
    key: "unapproved",
    value: 4,
    label: "Unapproved",
    color: "yellow",
    description: "GST Challan payment is waiting for approval.",
  },
  expired: {
    key: "expired",
    value: 5,
    label: "Expired",
    color: "red",
    description: "GST Challan has been expired as due das is passed. Further payment can not be made.",
  }
}

export const PAYMENT_STATUSTYPES = {
  pending: {
    key: "pending",
    value: 1,
    label: "Pending",
    color: "yellow",
  },
  in_process: {
    key: "in_process",
    value: 2,
    label: "In Process",
    color: "blue",
  },
  success: {
    key: "success",
    value: 3,
    label: "Success",
    color: "green",
  },
  reversed: {
    key: "reversed",
    value: 4,
    label: "Reversed",
    color: "orange",
  },
  failure: {
    key: "failure",
    value: 5,
    label: "Failure",
    color: "red",
  }
}

export const getGSTColumns = (methods, current_user) => [
  // {
  //   title: "Financial Year",
  //   key: "financialYear",
  //   render: (record) => <Text4>{record.financial_year || "---"}</Text4>,
  // },
  {
    title: "GSTIN",
    key: "GSTin",
    render: (record) => <>
      <Text4>{record.gstin || "---"}</Text4>
      <Text5 className="d-block" secondary>{record.business_name}</Text5>
    </>
  },
  {
    title: "CPIN",
    key: "Cpin",
    render: (record) => (
      <Text4>{record.cpin || "---"}</Text4>
    ),
  },
  {
    title: "Due Date",
    key: "due_date",
    render: (record) => (
      <Text4>{record.expiry_date ? moment(record.expiry_date).format("LL") : "---"}</Text4>
    ),
  },
  {
    title: "Amount",
    key: "amount",
    render: (record) => (
      <Text4>{printRupee(record.total_amount || "---")}</Text4>
    ),
  },
  {
    title: (
      <span className="c-pointer" onClick={methods.toggleStatusInfoDrawer}>
        <span>Status</span>
        <Icon style={{ fontSize: 14 }} className="ml-1" type="info-circle" />
      </span>
    ),
    key: "status",
    render: (record) => (
      <Text4>
        {<Badge color={STATUSTYPES[record.status.toLowerCase()].color} text={<Text4>{record.status}</Text4>} />}
      </Text4>
    ),
  },
  {
    title: "Action",
    key: "action",
    render: (record) => (
      <div>
        <Text4>
          <Button
            onClick={() => methods.toggleGSTDetailsDrawer(record)}
            type="link"
          >
            View details
          </Button>
        </Text4>
      </div>
    ),
  },
];

export const gstTableFilterNodes = (params = {}) => {
  let virtual_accounts = params.virtual_accounts;
  let merchant_payment_modes = [];
  // PAYMENT_METHODS.forEach(payment_method => {
  //    if (params.merchant_payment_modes.includes(payment_method.value)) {
  //        merchant_payment_modes.push(payment_method.value)
  //    }
  // });

  const fy = [
    {
      id: 1,
      value: "2020 - 2021",
    },
    {
      id: 2,
      value: "2018 - 2019",
    },
    { id: 3, value: "2017 - 2018" },
  ];

  return [
    // {
    //   label: "Financial Year",
    //   field: "financialYear",
    //   placeholder: "Financial Year",
    //   inputType: "select",
    //   defaultValue: undefined,
    //   options: fy.map((item, index) => {
    //     return {
    //       key: item.id,
    //       value: item.value,
    //       label: item.value,
    //     };
    //   }),
    // },
    {
      label: "GSTIN",
      field: "gstin",
      placeholder: "GSTIN",
      inputType: "text",
      width: 200,
      disabled: false,
      defaultValue: undefined,
    },
    {
      label: "CPIN",
      field: "cpin",
      placeholder: "CPIN",
      inputType: "text",
      defaultValue: "",
    },
    {
      label: "Amount",
      field: "amount",
      placeholder: "Amount",
      inputType: "text",
      defaultValue: "",
    },
    {
      label: "Status",
      field: "status",
      placeholder: "Status",
      inputType: "select",
      defaultValue: undefined,
      options: Object.keys(STATUSTYPES).map((type, index) => {
        let object = {};
        object.key = index;
        object.value = STATUSTYPES[type].value;
        object.label = (
          <Badge
            color={STATUSTYPES[type].color}
            text={<Text4>{STATUSTYPES[type].label}</Text4>}
          />
        );
        return object;
      }),
    },
  ];
};
